var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.275 10.9188L10.425 12.9188C10.8312 13.175 11.3312 12.7938 11.2125 12.325L10.3 8.73752C10.2753 8.63807 10.2792 8.53369 10.3113 8.43638C10.3434 8.33907 10.4023 8.2528 10.4812 8.18752L13.3062 5.83127C13.675 5.52502 13.4875 4.90627 13.0062 4.87502L9.31875 4.63752C9.21813 4.63166 9.1214 4.59663 9.04038 4.53669C8.95935 4.47675 8.89754 4.39451 8.8625 4.30002L7.4875 0.837515C7.4511 0.737455 7.38479 0.651018 7.29758 0.589938C7.21037 0.528858 7.10647 0.496094 7 0.496094C6.89352 0.496094 6.78963 0.528858 6.70241 0.589938C6.6152 0.651018 6.54889 0.737455 6.5125 0.837515L5.1375 4.30002C5.10245 4.39451 5.04064 4.47675 4.95962 4.53669C4.87859 4.59663 4.78186 4.63166 4.68125 4.63752L0.993747 4.87502C0.512497 4.90627 0.324997 5.52502 0.693747 5.83127L3.51875 8.18752C3.59771 8.2528 3.65661 8.33907 3.68868 8.43638C3.72075 8.53369 3.72467 8.63807 3.7 8.73752L2.85625 12.0625C2.7125 12.625 3.3125 13.0813 3.79375 12.775L6.725 10.9188C6.8072 10.8665 6.90259 10.8387 7 10.8387C7.09741 10.8387 7.1928 10.8665 7.275 10.9188Z",
    fill: "#EED382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.130b480021ef283ce449fcb08375e6cd.svg";
export { ForwardRef as ReactComponent };